export const hourRangeSchema = {
    displayName: 'hour range',
    type: 'object',
    fields: {
        from: {
            type: 'dayTimestamp',
            required: true,
        },
        to: {
            type: 'dayTimestamp',
            required: true,
        },
    },
};
//# sourceMappingURL=hour_range_schema.js.map